import React from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

/** Layout component. The page components will be nested in this component. */
export const Layout = ({ children }) => (
  <div>
    <NavMenu />
    <Container>
      {children}
    </Container>
  </div>
);
